import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    SET_MESSAGE,
  } from "../types";
  import { Dispatch } from 'redux';//, bindActionCreators
  //import { createAction } from 'redux-actions';
  

  import AuthService from "../../services/auth.service";
  
  export const registerAction = (customerData:any) => (dispatch:Dispatch) => {
    return AuthService.register(customerData).then(
      (response:any) => {
        dispatch({
          type: REGISTER_SUCCESS,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: response.data.message,
        });
  
        return Promise.resolve();
      },
      (error:any) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: REGISTER_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };
  
  export const login = (username:any, password:any) => (dispatch:Dispatch) => {
    return AuthService.login(username, password).then(
      (data:any) => {
        console.log("VV: Auth Service Logged in succesfully");
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data },
        });
        dispatch({
          type: SET_MESSAGE,
          payload:{ message:"Login success",variant:'success'},
        });
        return Promise.resolve();
      },
      (error:any) => {
        console.log("VV: Exception in Auth Service Login method");
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          
        dispatch({
          type: LOGIN_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: {message,variant:'danger'},
        });
  
        return Promise.reject();
      }
    );
  };
  
  export const logout = () => (dispatch:Dispatch) => {
    AuthService.logout();
    dispatch({
      type: LOGOUT,
    });
  };